import { DASH } from "../Services/dashboardconstants";
import Dashboardservice from "../Services/dashboardservice";

export const login = (data) => async (dispatch) => {
    request();
    const res = await Dashboardservice.onLogin(data)
    try {
        success(res);
        localStorage.setItem('loginData', JSON.stringify(res.data));
        return Promise.resolve(res.data);
       
    } catch (err) {
        failure(err)
        return Promise.reject(err);
    }

    function request() {
        dispatch({ type: DASH.REQUEST_LOGIN });
    };

    function success(res) {
        dispatch({ type: DASH.SUCCESS_LOGIN, payload: res.data });
    };
    function failure(err) {
        dispatch({
            type: DASH.FAILED_LOGIN,
            payload: err
        });
    };
};
export const getBearerToken = (data) => async (dispatch) => {
    request();

    const res = await Dashboardservice.callToken(data);
    try {
        success(res);

        console.log('isssssss',JSON.stringify(res))
        
        return Promise.resolve(res.data);
    } catch (err) {
        console.log('issssssseeee',JSON.stringify(err))
        failure(err)
        return Promise.reject(err);
    }

    function request() {
        dispatch({ type: DASH.REQUEST_TOKEN });
    };

    function success(res) {
        dispatch({ type: DASH.SUCCESS_TOKEN, payload: res.data });
    };
    function failure(err) {
        dispatch({
            type: DASH.FAILED_TOKEN,
            payload: err
        });
    };
};